module.exports = __webpack_public_path__ + "img/mtnce-filter.9de5ee25.jpg";